import { render } from "./ExpenseBar.vue?vue&type=template&id=2d8e36a1"
import script from "./ExpenseBar.vue?vue&type=script&lang=js"
export * from "./ExpenseBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\partner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__